var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-07-19
 * @brief SEI Management - 승인관리 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { alertState } from "../../../recoil/assessmentState";
// useState
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import { useNavigate } from "react-router-dom";
import { getApiLangState } from "../../../recoil/langState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
import EhpPagination from "../../common/pagination/EhpPagination";
function UserApproval(props) {
    // 화면 이동
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [user, setUser] = useState(null);
    // props
    const { handleOpenPop } = props;
    // useState
    const [reload, setReload] = useState(false);
    const [userDisplayDone, setUserDisplayDone] = useState(false);
    const [userDisplayCompanion, setUserDisplayCompanion] = useState(false);
    const [userType, setUserType] = useState(null);
    const [addList, setAddList] = useState([]);
    const [addListResult, setAddListResult] = useState([]);
    const [errorList, setErrorList] = useState([]);
    const [newCompanyInfo, setNewCompanyInfo] = useState(null);
    const langApi = useRecoilValue(getApiLangState);
    const roleType = [
        {
            id: "0",
            value: CONST.USERROLE_NONE,
            fname: "NONE" /* active: false */,
        },
        {
            id: "1",
            value: CONST.USERROLE_ADMIN,
            fname: "Admin" /* active: false */,
        },
        {
            id: "2",
            value: CONST.USERROLE_ENGINEER,
            fname: "Engineer" /* active: false */,
        },
        {
            id: "3",
            value: CONST.USERROLE_SUPER,
            fname: "Super User" /* active: false */,
        },
        {
            id: "4",
            value: CONST.USERROLE_USER,
            fname: "User" /* active: false */,
        },
    ];
    const [companyItem, setCompanyItem] = useState([]);
    const [companyAdd, setCompanyAdd] = useState([]);
    const [zoneItem, setZoneItem] = useState([]);
    const [zoneAdd, setZoneAdd] = useState([]);
    useEffect(() => {
        handleOpenPop("pop-user-add", user && (_jsx(CompanyZoneCreatePop, { user: user, userType: userType, companyClick: companyClick, listDelete: listDelete, companyItem: companyItem, companyAdd: companyAdd, zoneItem: zoneItem, zoneAdd: zoneAdd, setZoneAdd: setZoneAdd, addList: addList, setAddList: setAddList, setAddListResult: setAddListResult, htmlClose: _jsxs(_Fragment, { children: [user && (_jsxs("h1", { children: [t("라벨.신규가입자"), " _ ", user.userName, " ", !enabled ? "(미인증)" : ""] })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => CloseInnerPop("pop-user-add") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) })));
    }, [user, userType, companyItem, companyAdd, zoneItem, zoneAdd, addList]);
    // user
    const [users, setUsers] = useState([]);
    const [enabled, setEanbled] = useState(false);
    const [totalCount, setTotalCount] = useState([]);
    // page
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    let appPath = "page=" + pageInfo.number + "&size=" + pageInfo.size;
    let appPath2 = "page=" + 0 + "&size=" + pageInfo.totalElements;
    // 신규 가입자 List
    const { data: data, isLoading, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/users/approval?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload,
    });
    useEffect(() => {
        // error page 이동
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setUsers(data.body);
                setPageInfo(data.data.page);
            }
        }
    }, [data]);
    // 승인할 유저 총합용
    const { data: totaldata } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/users/approval?${appPath2}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath2 + reload,
    });
    useEffect(() => {
        // error page 이동
        if (totaldata) {
            if (totaldata.codeNum == CONST.API_200) {
                setTotalCount(totaldata.body);
            }
        }
    }, [totaldata]);
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
    }
    function CloseInnerPop(id) {
        CUTIL.inner_jsclose_Popup(id);
    }
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    function ApprovalPop(e, user) {
        return __awaiter(this, void 0, void 0, function* () {
            // e => 이벤트 호출 == 팝업 띄우기
            // obj == 해당 리스트에대한 정보 추출
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/user/${user.userIdPk}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
                watch: user.userIdPk,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setUser(data.body);
                    setEanbled(user.enabled);
                    CUTIL.jsopen_Popup(e);
                    if (data.body.approval == 2) {
                        setUserDisplayDone(true);
                    }
                    else {
                        setUserDisplayDone(false);
                    }
                    setUserDisplayCompanion(false);
                    userTypeSelect(roleType[0]);
                    setUserType(roleType[0]);
                }
            }
        });
    }
    // 사용자 타입
    function userTypeSelect(type) {
        setErrorList(errorList.filter((err) => err.field !== "role"));
        setUserType(type);
        if (type !== userType) {
            setAddList([]);
            setAddListResult([]);
        }
    }
    // 승인 API
    function approvalChang(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${user.userIdPk}/approval`,
                appQuery: {
                    approval: 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setUser(Object.assign(Object.assign({}, user), { approval: 2 }));
                    setEanbled(true);
                    setUserDisplayCompanion(false);
                    setUserDisplayDone(true);
                    setReload(true);
                }
            }
        });
    }
    // 반려 display
    function onCompanion(e) {
        if (userDisplayCompanion === false) {
            setUserDisplayCompanion(true);
            setUserDisplayDone(false);
        }
        else if (user.enable === false) {
            setUserDisplayCompanion(false);
        }
    }
    // 승인 선택
    function onDone(e) {
        if (userDisplayDone === false) {
            setUserDisplayDone(true);
            setUserDisplayCompanion(false);
            setReload(true);
        }
    }
    // ApprovalPop - site addPop ListAdd
    function listAdd(e, companyAdd, zoneAdd, list) {
        var listVal = {
            userIdPk: list.userIdPk,
            companyId: companyAdd.companyId,
            companyName: companyAdd.companyName,
            zoneId: zoneAdd.zoneId,
            zoneName: zoneAdd.zoneName,
            address: zoneAdd.address,
        };
        if (zoneAdd != "") {
            setAddList([...addList, listVal]);
        }
    }
    // ApprovalPop - site addPop ListDelete
    function listDelete(list) {
        setAddList(addList.filter((delList) => delList.zoneId !== list.zoneId));
        setAddListResult(addListResult.filter((delList) => delList.zoneId !== list.zoneId));
    }
    // 회사 목록 API
    function companySelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: "/product/companies",
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (userType.id <= 2) {
                        setCompanyItem(data.body);
                        companyClick(null);
                    }
                    else {
                        let companyArr = null;
                        data.body.filter((cf) => cf.companyName == user.company.companyName).map((item) => (companyArr = item));
                        companyClick(companyArr);
                    }
                    CUTIL.jsopen_InteriorPopup(e);
                }
            }
        });
    }
    // 회사 선택 시 사업장 API 연계까지
    function companyClick(company) {
        return __awaiter(this, void 0, void 0, function* () {
            if (company) {
                // 셀렉트 선택 시 data
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "GET",
                    appPath: `/product/zones`,
                    appQuery: {
                        language: langApi,
                        companyId: company.companyId,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setZoneItem(data.body);
                        setCompanyAdd(company);
                        setZoneAdd([]);
                    }
                }
            }
            else {
                setZoneItem([]);
                setCompanyAdd([]);
                setZoneAdd([]);
            }
        });
    }
    // 신규회사 목록 팝업
    function companyNew(e, item) {
        return __awaiter(this, void 0, void 0, function* () {
            setNewCompanyInfo(item);
            CUTIL.jsopen_Popup(e);
            // 셀렉트 선택 시 data
        });
    }
    useEffect(() => {
        handleOpenPop("pop-company-new", user && _jsx(NewCompanyPop, { newCompanyInfo: newCompanyInfo }));
    }, [newCompanyInfo]);
    // 승인 할 유저 카운트
    const approval = totalCount == null ? null : totalCount.filter((data) => data.approval != 0 && data.approval != 3).length;
    // // 중복제거 이벤트
    // const addLists = addList.filter((arr, index, callback) => index === callback.findIndex(t => t.zoneId === arr.zoneId));
    useEffect(() => {
        handleOpenPop("pop-admin-ok", _jsx(RequestApproval, { user: user, roleType: roleType, userType: userType, userTypeSelect: userTypeSelect, errorList: errorList, approvalChang: approvalChang, userDisplayDone: userDisplayDone, userDisplayCompanion: userDisplayCompanion, onCompanion: onCompanion, onDone: onDone, addListResult: addListResult, listDelete: listDelete, companySelect: companySelect, setErrorList: setErrorList, companyNew: companyNew, htmlClose: _jsxs(_Fragment, { children: [user && (_jsxs("h1", { children: [t("라벨.신규가입자"), " _ ", user.userName, " ", !enabled ? `(${t("라벨.미인증")})` : ""] })), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-admin-ok") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [user, userType, userDisplayDone, userDisplayCompanion, addListResult]);
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsx("h2", Object.assign({ className: "box__title" }, { children: t("라벨.신규가입승인요청") })) })), users && (_jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsx("div", Object.assign({ className: "right" }, { children: _jsxs("p", Object.assign({ className: "user-num" }, { children: [_jsx("span", { children: approval }), t("라벨.개")] })) })) })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "\uD68C\uC0AC,\uC774\uB984 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2E0\uADDC \uAC00\uC785 \uC2B9\uC778 \uC694\uCCAD \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC2E0\uADDC \uAC00\uC785 \uC2B9\uC778 \uC694\uCCAD \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "110px" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.회사") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.이름") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.승인요청") }))] }) }), _jsxs("tbody", { children: [users
                                            .filter((list) => list.approval != 0 && list.approval != 3)
                                            .map((list) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: `txt-left ${list.enabled == false ? "icon-dot disabled" : ""} ` }, { children: list.companyName })), _jsx("td", Object.assign({ className: `txt-left ${list.enabled == false ? "icon-dot disabled pl-22" : ""} ${list.enabled == false ? "disabled" : ""} ` }, { children: _jsx("span", { children: list.userName }) })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic js-open", "data-pop": "pop-admin-ok", onClick: (e) => ApprovalPop(e, list) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-admin-ok" }, { children: t("라벨.확인") })) })) })] }, list.userIdPk))), users
                                            .filter((list) => list.approval != 0 && list.approval == 3)
                                            .map((list) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "txt-left" }, { children: list.companyName })), _jsx("td", Object.assign({ className: "txt-left" }, { children: list.userName })), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", disabled: true }, { children: _jsx("span", { children: t("라벨.승인완료") }) })) })] }, list.userIdPk)))] })] })) })), pageInfo && (_jsx(EhpPagination, { componentName: "UserApproval", pageInfo: pageInfo, handleCurPage: handleCurPage, dispLabel: t("라벨.최근90일") }))] })))] }));
}
export default UserApproval;
//신규 가입자요청 팝업
function RequestApproval(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [companionTxt, setCompanionTxt] = useState("");
    // props
    const { user, roleType, userType, userTypeSelect, errorList, approvalChang, userDisplayDone, userDisplayCompanion, onCompanion, onDone, addListResult, listDelete, companySelect, setErrorList, companyNew, } = props;
    useEffect(() => {
        setCompanionTxt("");
    }, [userDisplayCompanion]);
    // 반려 완료
    function userApprovalDel(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/user/${list.userIdPk}/approval`,
                appQuery: {
                    approval: 0,
                    deniedReason: companionTxt,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "메일 전송이 완료되었습니다." }));
                    window.location.reload();
                }
            }
        });
    }
    // 승인 완료
    function userApprovalDone(list) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/auth/user/${list.userIdPk}/roleusertree`,
                appQuery: {
                    role: userType.value,
                    usertree: addListResult.map((el) => ({
                        product: "zone",
                        productName: el.zoneName,
                        productParentId: el.companyId,
                        approval: 2,
                        isontree: true,
                    })),
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: "사용자 승인 요청이 완료되었습니다." }));
                    window.location.reload();
                }
                else {
                    setErrorList(data.errorList);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("div", Object.assign({ className: "flex-row m-mt-16" }, { children: [_jsx("div", Object.assign({ className: "pop-left" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit w185" }, { children: ["E-mail (", t("라벨.아이디"), ")", t("라벨.명")] })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: user ? user.userId : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: t("라벨.이름") })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: user ? user.userName : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: t("라벨.연락처") })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: user ? user.phoneNumber : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: t("라벨.회사") })), _jsxs("div", Object.assign({ className: "input__area w280" }, { children: [user && user.company.isApproved == 1 && (_jsx("button", Object.assign({ type: "button", className: "btn-new js-open", "data-pop": "pop-company-new", onClick: (e) => companyNew(e, user.company) }, { children: _jsx("span", { children: "New" }) }))), _jsx("input", { type: "text", id: "", value: user ? user.company.companyName : "", readOnly: true })] }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: t("라벨.부서") })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: user ? user.department : "-", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit w185" }, { children: t("라벨.업종") })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsx("input", { type: "text", id: "", value: user ? user.classification : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star w185" }, { children: t("라벨.승인여부") })), _jsx("div", Object.assign({ className: "input__area w280" }, { children: _jsxs("div", Object.assign({ className: "flex-inline" }, { children: [_jsx("button", Object.assign({ type: "button", className: `btn-basic h40 w136 ${user && user.approval == 2 && userDisplayDone ? "bg-navy" : ""}`, onClick: (e) => (!userDisplayDone ? approvalChang(user) : onDone(e)) }, { children: _jsx("span", Object.assign({ className: "font-16 fontBold" }, { children: t("라벨.승인") })) })), _jsx("button", Object.assign({ type: "button", className: `btn-basic h40 w136 ml-8 ${userDisplayCompanion ? "bg-navy" : ""}`, onClick: (e) => onCompanion(e) }, { children: _jsx("span", { children: t("라벨.반려") }) }))] })) }))] })] })) })), _jsx("div", Object.assign({ className: "pop-right w100p" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-0" }, { children: [!userDisplayCompanion && (_jsx(IsSavedApproval, { user: user, roleType: roleType, userType: userType, userTypeSelect: userTypeSelect, approvalChang: approvalChang, userDisplayDone: userDisplayDone, userDisplayCompanion: userDisplayCompanion, onCompanion: onCompanion, onDone: onDone, errorList: errorList, addListResult: addListResult, listDelete: listDelete, companySelect: companySelect })), userDisplayCompanion && (_jsx(Companion, { errorList: errorList, companionTxt: companionTxt, setCompanionTxt: setCompanionTxt }))] })) }))] })) })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: userDisplayCompanion ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => userApprovalDel(user) }, { children: _jsx("span", { children: t("라벨.완료") }) }))) : userDisplayDone && user.approval == 2 ? (_jsx("button", Object.assign({ type: "button", onClick: (e) => userApprovalDone(user) }, { children: _jsx("span", { children: t("라벨.완료") }) }))) : (_jsx("button", Object.assign({ type: "button", disabled: true }, { children: _jsx("span", { children: t("라벨.완료") }) }))) }))] }));
}
// 사용자 타입 및 회사_사업장 목록
function IsSavedApproval(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    // props
    const { user, roleType, userType, userTypeSelect, userDisplayDone, errorList, addListResult, listDelete, companySelect, } = props;
    useEffect(() => { }, [roleType, userType, userTypeSelect, userDisplayDone, addListResult, listDelete, errorList]);
    return (_jsxs(_Fragment, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star w185" }, { children: t("라벨.사용자타입") })), _jsxs("div", Object.assign({ className: "input__area w375" }, { children: [_jsx("div", Object.assign({ className: `radioBox
              ${errorList.filter((err) => err.field === "role").length > 0 ? "input-error" : ""}` }, { children: userInfo.role === CONST.USERROLE_SUPER
                                    ? roleType
                                        .filter((type) => type.id != 0)
                                        .map((type) => (_jsxs("label", Object.assign({ id: "rd_" + type.id }, { children: [_jsx("input", { type: "radio", id: "rd_" + type.id, name: "rd", checked: userType && userType.id === type.id ? true : false, onChange: (e) => userTypeSelect(type), disabled: (user && user.approval == 1) ||
                                                    (userType && "rd_" + type.id == "rd_1") ||
                                                    (userType && "rd_" + type.id == "rd_2") ||
                                                    !userDisplayDone
                                                    ? true
                                                    : false }), type.fname] }), type.id)))
                                    : roleType
                                        .filter((type) => type.id != 0)
                                        .map((type) => (_jsxs("label", Object.assign({ id: "rd_" + type.id }, { children: [_jsx("input", { type: "radio", id: "rd_" + type.id, name: "rd", checked: userType && userType.id === type.id ? true : false, onChange: (e) => userTypeSelect(type), disabled: (user && user.approval == 1) || !userDisplayDone ? true : false }), type.fname] }), type.id))) })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: t("라벨.필수항목을입력하지않으셨습니다") }))] }))] }), _jsx("li", { children: _jsxs("div", Object.assign({ className: "flex-column" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top w100p" }, { children: [_jsx("p", Object.assign({ className: "tit mt-0" }, { children: t("라벨.회사사업장목록") })), _jsx("button", Object.assign({ type: "button", className: "btn-basic", "data-pop": "pop-user-add", onClick: (e) => companySelect(e), disabled: !userDisplayDone || (userType && userType.id == 1) || (userType && userType.id == 3) ? true : false }, { children: _jsx("span", Object.assign({ "data-pop": "pop-user-add" }, { children: t("라벨.추가") })) }))] })), _jsx("div", Object.assign({ className: "tbl-list scrollH h295" }, { children: _jsxs("table", Object.assign({ summary: "No,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "40%" } }), _jsx("col", { style: { width: "10%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.회사명") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.사업장명") })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), _jsx("tbody", { children: addListResult &&
                                            addListResult.map((add, idx) => (_jsxs("tr", { children: [_jsx("td", { children: ++idx }), _jsx("td", { children: add.companyName }), _jsx("td", { children: add.zoneName }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-g", onClick: (e) => listDelete(add) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }, add.zoneId))) })] })) }))] })) }), _jsxs("p", Object.assign({ className: "txt-info txt-middlegray font-13 ml-0 mt-4" }, { children: ["* ", t("라벨.사용자타입변경시목록초기화")] }))] }));
}
// 신규가입자- 반려
function Companion(props) {
    const t = useTrans();
    // props
    const { companionTxt, setCompanionTxt, errorList } = props;
    return (_jsx(_Fragment, { children: _jsxs("li", Object.assign({ className: "flex-column" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.반려사유") })), _jsxs("div", Object.assign({ className: "input__area mt-19" }, { children: [_jsx("textarea", { rows: 2, className: `h186 ${errorList.filter((err) => err.field === "deniedReason").length > 0 ? " input-error" : ""}`, placeholder: t("라벨.텍스트입력"), value: companionTxt, onChange: (e) => setCompanionTxt(e.target.value) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "deniedReason").map((err) => err.msg) }))] }))] })) }));
}
// 신규 가입자 - 회사_사업장 등록
function CompanyZoneCreatePop(props) {
    const t = useTrans();
    // props
    const { user, userType, companyClick, listDelete, companyItem, companyAdd, zoneItem, zoneAdd, setZoneAdd, addList, setAddList, setAddListResult, } = props;
    const [zoneInfo, setZoneInfo] = useState(null);
    // 사업장 이벤트
    function zoneClick(zone) {
        setZoneAdd(zone);
        setZoneInfo(zone);
        var listVal = {
            userIdPk: user.userIdPk,
            companyId: companyAdd.companyId,
            companyName: companyAdd.companyName,
            zoneId: zone.zoneId,
            zoneName: zone.zoneName,
            address: zone.address,
        };
        setAddList([...addList, listVal]);
    }
    // 회사_사업장 등록 이벤트
    function CompanyZoneAdd(list) {
        return __awaiter(this, void 0, void 0, function* () {
            setAddListResult(list);
            CUTIL.inner_jsclose_Popup("pop-user-add");
        });
    }
    function CloseInnerPop(id) {
        setAddListResult([]);
        CUTIL.inner_jsclose_Popup(id);
    }
    // 중복제거 이벤트
    const addLists = addList.filter((arr, index, callback) => index === callback.findIndex((t) => t.zoneId === arr.zoneId));
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top mb-24" }, { children: _jsxs("div", Object.assign({ className: "left" }, { children: [_jsx("span", Object.assign({ className: "mr-16 font-14 star" }, { children: _jsx("strong", { children: t("라벨.회사명") }) })), userType && userType.id <= 2 ? (_jsxs("div", Object.assign({ className: "select w278", id: "company", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: t("라벨.클릭선택") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ id: "company_change", className: "option hide", onClick: (e) => companyClick("") }, { children: t("라벨.클릭선택") })), companyItem &&
                                                    companyItem.map((list) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => companyClick(list) }, { children: list.companyName }), list.comapanyName)))] })] }))) : (_jsx("div", Object.assign({ className: " w278", id: "company" }, { children: _jsx("input", { type: "text", id: "", value: (user && user.company.companyName) || "", readOnly: true }) }))), _jsx("span", Object.assign({ className: "ml-48 mr-16 font-14 star" }, { children: _jsx("strong", { children: t("라벨.사업장명") }) })), _jsxs("div", Object.assign({ className: "select w278", id: "zone", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: zoneAdd.length <= 0 ? t("라벨.클릭선택") : zoneInfo.zoneName })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ id: "zone_change", className: "option hide", onClick: (e) => zoneClick("") }, { children: t("라벨.클릭선택") })), zoneItem &&
                                                    zoneItem.map((list) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => zoneClick(list) }, { children: list.zoneName }), list.zoneId)))] })] }))] })) })), _jsx("div", Object.assign({ className: "tbl-list scrollH h336 mb-32" }, { children: _jsxs("table", Object.assign({ summary: "No,\uD68C\uC0AC \uBA85,\uC0AC\uC5C5\uC7A5 \uBA85 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "47%" } }), _jsx("col", { style: { width: "8%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.회사명") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.사업장명") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.주소") })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) }))] }) }), _jsx("tbody", { children: addLists &&
                                        addLists.map((add, idx) => (_jsxs("tr", { children: [_jsx("td", { children: ++idx }), _jsx("td", { children: add.companyName }), _jsx("td", { children: add.zoneName }), _jsx("td", { children: add.address }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-g", onClick: (e) => listDelete(add) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }, add.zoneId))) })] })) }))] })), _jsxs("div", Object.assign({ className: "popup__footer right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray", onClick: (e) => CloseInnerPop("pop-user-add") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "mr-15 js-close", onClick: (e) => CompanyZoneAdd(addLists) }, { children: _jsx("span", { children: t("라벨.등록") }) }))] }))] }));
}
function NewCompanyPop(props) {
    const t = useTrans();
    const { newCompanyInfo } = props;
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.회사명") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "", value: newCompanyInfo ? newCompanyInfo.companyName : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.회사UR"), "L"] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "", value: newCompanyInfo ? newCompanyInfo.url : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.사업자등록번호") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "", value: newCompanyInfo ? newCompanyInfo.businessNo : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.대표관리자") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "", value: newCompanyInfo ? newCompanyInfo.administrator : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.청구정산담당") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "", value: newCompanyInfo ? newCompanyInfo.accountManager : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.청구정산담당"), " Tel"] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp10", value: newCompanyInfo ? newCompanyInfo.accMngrTelephone : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "I/F Info" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp11", value: newCompanyInfo ? newCompanyInfo.interfaceInfo : "", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.메모") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("textarea", { value: newCompanyInfo ? newCompanyInfo.memo : "", disabled: true }) }))] })] })) })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "js-close" }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] }));
}
